var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { Component, Vue, Watch, PropSync, Prop } from 'vue-property-decorator';
import { SummaryFilters as SummaryFiltersInterface } from '@/components/subject-overview-new/SubjectOverviewNew';
import { debounce } from 'lodash';
import LevelFilter from '@/components/SummaryFilters/LevelFilter/LevelFilter';
import PeriodFilter from '@/components/SummaryFilters/PeriodFilter/PeriodFilter';
import SubjectLabelFilter from '@/components/SummaryFilters/SubjectLabelFilter/SubjectLabelFilter';
import StatusFilter from '@/components/SummaryFilters/StatusFilter/StatusFilter';
import TopicFilter from '@/components/SummaryFilters/TopicFilter/TopicFilter';
import AreaFilter from '@/components/SummaryFilters/AreaFilter/AreaFilter';
import { Route } from 'vue-router';
import YearSelect from '@/components/YearSelect/YearSelect';
import TrashedSelect from '@/components/TrashedSelect/TrashedSelect';
import GoalsetSelect from '@/components/GoalsetSelect/GoalsetSelect';
import { Group } from '@/models/Group';
let SummaryFilters = class SummaryFilters extends Vue {
    constructor() {
        super(...arguments);
        this.internalDefaultFilter = this.defaultGoalsetFilter;
        this.debounceEmitFilters = debounce(this.emitFilters, 200);
        this.selectedYear = '';
    }
    mounted() {
        this.onMounted();
    }
    async onMounted() {
        this.internalFilters.groups = getGroupsFromRoute(this.$route);
        // this.debounceEmitFilters();
    }
    emitFilters() {
        // this.$emit('input', this.internalFilters);
    }
    selectedYearChanged(selectedYear) {
        this.internalFilters.updated_at = selectedYear;
    }
    onGoalsetFilterChanged(value) {
        this.$emit('goalset-filter-changed', value);
    }
    get isGroup() {
        return !!this.internalFilters.groups && this.internalFilters.groups.length > 0;
    }
    get goalSelectOptions() {
        if (this.group && this.group.projects && this.group.projects.length > 0) {
            return [
                { value: 'all-goals', label: this.$tc('goalsetSelect.showAll') },
                { value: 'goalset-only', label: this.$tc('goalsetSelect.showGoalsetOnly') },
            ];
        }
        return [
            { value: 'all-goals', label: this.$tc('goalsetSelect.showAll') },
        ];
    }
    get studentProfileLevels() {
        return Array.from(Array(10).keys()).map((level) => {
            return {
                value: level + 1,
                text: `${this.$tc('grade')} ${level + 1}`,
            };
        });
    }
    routeChanged(newRoute) {
        this.internalFilters.groups = getGroupsFromRoute(newRoute);
        this.debounceEmitFilters();
    }
};
__decorate([
    PropSync('filters'),
    __metadata("design:type", typeof (_a = typeof SummaryFiltersInterface !== "undefined" && SummaryFiltersInterface) === "function" ? _a : Object)
], SummaryFilters.prototype, "internalFilters", void 0);
__decorate([
    Prop({ default: 'goalset-only' }),
    __metadata("design:type", String)
], SummaryFilters.prototype, "defaultGoalsetFilter", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof Group !== "undefined" && Group) === "function" ? _b : Object)
], SummaryFilters.prototype, "group", void 0);
__decorate([
    Watch('$route'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_c = typeof Route !== "undefined" && Route) === "function" ? _c : Object]),
    __metadata("design:returntype", void 0)
], SummaryFilters.prototype, "routeChanged", null);
SummaryFilters = __decorate([
    Component({
        components: {
            LevelFilter,
            PeriodFilter,
            SubjectLabelFilter,
            StatusFilter,
            YearSelect,
            TrashedSelect,
            TopicFilter,
            AreaFilter,
            GoalsetSelect,
        },
    })
], SummaryFilters);
export default SummaryFilters;
const getGroupsFromRoute = (route) => (route.query && route.query.groups ? (Array.isArray(route.query.groups) ? route.query.groups : [route.query.groups]) : []);
